import React from 'react'

import { LoadingIcon } from 'components/Icons'

import { Container } from './LoadingComponent.styles'

interface LoadingComponentProps {
  message?: string
  style?: React.CSSProperties
}

const LoadingComponent: React.FC<LoadingComponentProps> = ({
  message,
  style
}) => {
  return (
    <Container>
      <LoadingIcon
        marginLeft="auto"
        marginBottom="auto"
        marginRight="auto"
        marginTop="auto"
        colorIcon="#004C97"
        message={message}
        style={style}
      />
    </Container>
  )
}

export default LoadingComponent
